var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification-prove"},[_c('h1',[_vm._v(_vm._s(_vm.$lang('TITLE_CHECK_SUCCESS')))]),_c('h2',[_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v(_vm._s(_vm.$lang('TITLE_CLICK_LOGIN')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }